module.exports = __webpack_public_path__ + "static/media/PORTADA_CICLO_4_CIUDADANO.1ebdeac5.jpg";